<template>
  <v-card
    class="d-flex align-md-center pa-2 flex-column flex-md-row flex-wrap"
    outlined
  >
    <div v-if="$slots['prepend']" class="pt-2 pr-md-2 pt-md-0">
      <slot name="prepend"></slot>
    </div>
    <div class="flex-grow-0 pl-2 pr-4 pb-2 pb-md-0">
      {{ length }} / {{ total }} {{ textAppend }}
    </div>
    <div v-if="$slots['left']" class="py-2 pl-md-2 py-md-0">
      <slot name="left"></slot>
    </div>
    <v-spacer></v-spacer>
    <div v-if="$slots['right']" class="py-2 pr-md-2 py-md-0">
      <slot name="right"></slot>
    </div>
    <div class="flex-grow-0 d-flex align-md-center justify-md-center">
      <template v-if="itemsOrderBy && itemsOrderBy.length > 0">
        <v-select
          dense
          :disabled="disabled"
          height="30px"
          hide-details
          v-model="orderBy.field"
          :items="itemsOrderBy"
          single-line
          @input="onUpdateOrderBy()"
          outlined
          return-object
          style="width: 200px"
          clearable
          @click:clear="onClear()"
        ></v-select>
        <div class="pl-2">
          <v-btn-toggle
            height="30px"
            dense
            :disabled="disabled || !orderBy.field"
            v-model="orderBy.sort"
            color="primary"
            @change="onUpdateOrderBy()"
            mandatory
          >
            <base-button
              outlined
              value="desc"
              :disabled="disabled || !orderBy.field"
            >
              <v-icon>mdi-arrow-down-bold-outline</v-icon>
            </base-button>
            <base-button
              outlined
              value="asc"
              :disabled="disabled || !orderBy.field"
            >
              <v-icon>mdi-arrow-up-bold-outline</v-icon>
            </base-button>
          </v-btn-toggle>
        </div>
      </template>
    </div>
    <div v-if="$slots['append-right']" class="pt-2 pl-md-2 pt-md-0">
      <slot name="append-right"></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    length: [String, Number],
    total: [String, Number],
    textAppend: String,
    headers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    orderBy: {
      field: null,
      sort: 'desc',
    },
  }),
  computed: {
    itemsOrderBy() {
      return this.headers.filter((x) => x.sortable)
    },
  },
  methods: {
    onUpdateOrderBy() {
      if (this.disabled) return
      if (!this.orderBy.field) {
        this.onClear()
        return
      }
      this.$emit('update:orderBys', [this.orderBy])
    },
    onClear() {
      this.$emit('update:orderBys', [])
    },
  },
}
</script>

<style scoped></style>
